export default "__VITE_ASSET__QTa2FM0q__"